import { ReactNode } from 'react';

import { makeStyles } from '@material-ui/core/styles';

import classNames from 'classnames';

const useStyles = makeStyles({
  root: {
    alignItems: 'center',
    border: '1px solid var(--essential-subdued)',
    borderRadius: 'var(--encore-corner-radius-smaller)',
    color: 'var(--text-subdued)',
    display: 'inline-flex',
    flexShrink: 0,
    height: 32,
    justifyContent: 'center',
    width: 32,
    '& > svg': {
      height: 14,
      width: 14,
    },
  },
});

interface ArtifactIconProps {
  children: ReactNode;
  className?: string;
}

export const ArtifactIcon = ({ children, className }: ArtifactIconProps) => {
  const classes = useStyles();
  return (
    <span className={classNames(classes.root, className)}>{children}</span>
  );
};
